import React, { useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { ADMIN_MENU_ITEMS } from './AdminPage';
import { useAdminSidebar } from '../ui/AdminSidebarContext';
import { useAuth } from '../AuthContext';
import useIdleTimeout from '../hooks/useIdleTimeout';

function AdminLayoutContent() {
  const { isOpen: adminSidebarOpen, close: closeAdminSidebar } = useAdminSidebar();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Add class to body for fixed navbar/sidebar on admin pages
  useEffect(() => {
    document.body.classList.add('admin-route');
    return () => document.body.classList.remove('admin-route');
  }, []);

  // Admin inactivity timeout: 30 minutes
  useIdleTimeout(1800000, 300000, () => {
    logout();
    localStorage.setItem('vedanta_session_message', 'Session expired due to inactivity');
    navigate('/account', { replace: true });
  });

  return (
    <>
      {/* Admin sidebar overlay - mobile only, visibility toggled via CSS */}
      <div
        className={`admin-sidebar-overlay${adminSidebarOpen ? ' active' : ''}`}
        onClick={closeAdminSidebar}
        aria-hidden="true"
      />

      {/* Admin sidebar - persistent on desktop, drawer on mobile */}
      <aside
        className={`admin-sidebar${adminSidebarOpen ? ' is-open' : ''}`}
        aria-label="Admin navigation"
      >
        <div className="admin-sidebar-header">
          <h3>Admin Panel</h3>
          <button
            type="button"
            className="admin-sidebar-close"
            onClick={closeAdminSidebar}
            aria-label="Close menu"
          >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
          </button>
        </div>
        <nav className="admin-sidebar-nav">
          {ADMIN_MENU_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => 'admin-sidebar-item' + (isActive ? ' active' : '')}
              onClick={closeAdminSidebar}
            >
              <i className={"fa-solid " + item.icon} aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-logout-btn"
            onClick={() => {
              navigate('/');
              closeAdminSidebar();
            }}
          >
            <i className="fa-solid fa-right-from-bracket" aria-hidden="true" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="admin-content">
        <Outlet />
      </main>
    </>
  );
}

export default function AdminLayout() {
  return (
    <div className="admin-layout">
      <AdminLayoutContent />
    </div>
  );
}